<span *ngFor="let item of items; index as i">
    <i [ngStyle]="{ background: item.color }"></i>
    {{ item.label }}
</span>
